// @ts-nocheck
import React, { FC } from 'react';
import { useFormApi } from 'informed';
import cn from 'classnames';
import { Button } from '@ui-modules';
import { Depart, Flag, Route } from '@assets/svg/icons';
import { TRANSFER_TYPES } from '@common/constants';
import { useNonSpammyFieldState } from '@common/hooks';
import { MultiSteps } from '@common/interfaces';
import { TextField } from '../../../../../legacyInputs';
import css from '../styles.module.scss';

interface ITransferTypeField {
  isEdit: boolean;
  city: string;
}

const TransferTypeField: FC<ITransferTypeField> = ({ isEdit, city }) => {
  const formApi = useFormApi();
  const { value: transfer_type } = useNonSpammyFieldState('transfer_type');

  return (
    <>
      <div className={css.labelTab}>{isEdit ? 'Transfer Type' : 'Select Transfer Type'}</div>
      <TextField name="transfer_type" type="hidden" />
      <div className={css.tabs}>
        {!isEdit || transfer_type === TRANSFER_TYPES.FROM_TO_AIRPORT ? (
          <Button
            text="To/From Airport"
            variant="primary"
            className={cn(css.buttonTab, {
              [css['buttonTab--edit']]: isEdit,
            })}
            onClick={() => {
              formApi.setValue('transfer_type', TRANSFER_TYPES.FROM_TO_AIRPORT);
              formApi.setValue(`${MultiSteps.TripInfo}.dropoff_town`, city);
            }}
            disabled={transfer_type === TRANSFER_TYPES.FROM_TO_AIRPORT}
            icon={<Depart />}
            data-testid="mobility-planner-edit-form-to-from-airport"
          />
        ) : null}
        {!isEdit || transfer_type === TRANSFER_TYPES.IN_TOWN ? (
          <Button
            text="In-Town"
            variant="primary"
            className={cn(css.buttonTab, {
              [css['buttonTab--edit']]: isEdit,
            })}
            onClick={() => {
              formApi.setValue('transfer_type', TRANSFER_TYPES.IN_TOWN);
              formApi.setValue(`${MultiSteps.TripInfo}.dropoff_town`, city);
            }}
            disabled={transfer_type === TRANSFER_TYPES.IN_TOWN}
            icon={<Flag />}
            data-testid="mobility-planner-edit-form-in-town"
          />
        ) : null}
        {!isEdit || transfer_type === TRANSFER_TYPES.OUT_TOWN ? (
          <Button
            text="Out-of-Town"
            variant="primary"
            className={cn(css.buttonTab, {
              [css['buttonTab--edit']]: isEdit,
            })}
            onClick={() => {
              formApi.setValue('transfer_type', TRANSFER_TYPES.OUT_TOWN);
              formApi.setValue(`${MultiSteps.TripInfo}.dropoff_town`, '');
            }}
            disabled={transfer_type === TRANSFER_TYPES.OUT_TOWN}
            icon={<Route />}
            data-testid="mobility-planner-edit-form-out-of-town"
          />
        ) : null}
      </div>
    </>
  );
};

export default TransferTypeField;
